
define('app/board/views/chatView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/collections/chatMessageCollection',
	
	//Templates
	'text!app/board/templates/chatMessageTemplate.html',
], function($, _, Backbone, UserModel, LeagueInstanceModel, DraftStatusModel, ChatMessageCollection, chatMessageHtml){
	var ChatView = Backbone.View.extend({
		initialize: function(options) {
			this.chatMessageCollection = options.chatMessageCollection;
			this.userModel = options.userModel;
			this.leagueModel = options.leagueModel;
			this.draftStatusModel = options.draftStatusModel;
			
			this.numUnread = 0;
			
			this.listenTo(this.chatMessageCollection, 'add', this.addMessage);
			this.listenTo(this.userModel, 'change', this.handlerUserPermissions);
			
			_.bindAll(this, 'chatToggleClick');
			_.bindAll(this, 'formEnter');
			_.bindAll(this, 'clearCounter');
			_.bindAll(this, 'submitChatMessage');
			_.bindAll(this, 'addMessage');
			_.bindAll(this, 'handlerUserPermissions');

			this.template = _.template(chatMessageHtml.trim());			
		},
		
		render: function () {
			this.handlerUserPermissions();
			
			//$('#chatPopTrigger').popover({
			//		placement: 'bottom', 
			//		trigger: 'manual', 
			//		content: function(){return $("#chatPopContent").html();}, });

			$('.chatNav a[data-toggle=dropdown]').on('click', this.chatToggleClick);
			$('.chatSubmitBtn').on('click', this.submitChatMessage);
			$('.chatForm').on("keyup", this.formEnter);
			$("#playerRankingsChatTextInput").on('focus', this.clearCounter);
			$("#playerRankingsChatTextInput").on('keyup', this.clearCounter);
			//$(".chatForm").submit(this.formSubmit);
			
			//Demo shouldn't have live messages so they should be preloaded
			if(this.draftStatusModel.get('demo')){
				this.initDemoMessages();
			}
			
			return this;
		},
		
		initDemoMessages: function() {
			this.chatMessageCollection.add([{
				userName: 'clickydraft', 
				message: 'Welcome to the Clicky Draft Demo!'}]);
			this.chatMessageCollection.add([{
				userName: 'clickydraft', 
				message: 'Clicky Draft is the perfect tool for both online and offline drafts.'}]);
			this.chatMessageCollection.add([{
				userName: 'consumer', 
				message: 'Can the rest of my league log in and draft as well?'}]);
			this.chatMessageCollection.add([{
				userName: 'clickydraft', 
				message: 'Absolutely! Once you create your league just give them the league name and password.  '
         		   + 'They can then pick a team and start drafting.  So if you have a live draft, but someone can\' attend'
        		   + ' just have them draft from Clicky Draft'}]);
			this.chatMessageCollection.add([{
				userName: 'consumer', 
				message: 'How many leagues am I able to create?'}]);
			this.chatMessageCollection.add([{
				userName: 'clickydraft', 
				message: 'Each purchase is good for the entire sport and year'
         		   +' that you bought.  So you can create as many leagues as you wish.'}]);
			this.chatMessageCollection.add([{
				userName: 'consumer', 
				message: 'Does the commissioner have to pick for everyone?'}]);
			this.chatMessageCollection.add([{
				userName: 'clickydraft', 
				message: 'Each team can pick for their own team, but the commissioner is able to make picks for any team.'}]);
			this.chatMessageCollection.add([{
				userName: 'consumer', 
				message: 'Sounds awesome.  Where can I find out more information?'}]);
			this.chatMessageCollection.add([{
				userName: 'clickydraft', 
				message: 'Getting Clicky Draft is easy.  Just go ahead and register for an account on the home page.  Once you'
         		   + ' are registered you can either purchase Clicky Draft or join an existing Clicky Draft league\'s draft'}]);
		
			//$("#draftPlayerInput").val('Disabled in demo');
		},
		
		handlerUserPermissions: function () {
			var chatDisabledEls = $(".chatDisabled");
			var chatFormEls = $(".chatForm");
			
			if(this.userModel.isGuest() || !this.leagueModel.getLeagueUser(this.userModel.get('userName'))){
				chatDisabledEls.removeClass('hide');
				chatFormEls.addClass('hide');
			} else {
				chatDisabledEls.addClass('hide');
				chatFormEls.removeClass('hide');
			}
		},
		
		chatToggleClick: function() {
			this.clearCounter();
			
			var chatBox = $(".chatNav .chatMessages");
			chatBox.first().scrollTop(chatBox.first().prop("scrollHeight"));
			
			if(this.draftStatusModel.get('demo')){
				$("#chatTextInput").val('Chat disabled for demo');
			}
			
			setTimeout(function() { $("#chatTextInput").focus();}, 200);
		},
		
		clearCounter: function() {
			this.numUnread = 0;
			var unreadEl = $("#chatUnreadNbr");
			unreadEl.html(this.numUnread);
			unreadEl.removeClass("badge-important");
			unreadEl.addClass("badge-success");
		},
		
		/*formSubmit: function(e) {
			e.preventDefault();
			this.submitChatMessage(e);
			return false;
		},*/
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.submitChatMessage(e);
				return false;
			}
		},
		
		submitChatMessage: function(event) {
			event.preventDefault();
			var msg = $("#chatTextInput").val();
			
			if(!msg){
				msg = $("#playerRankingsChatTextInput").val();
			}
			
			if(!this.draftStatusModel.get('demo')){
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : 
						'/draftapp/leagues/' 
						+ this.leagueModel.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueModel.get('id') 
						+ '/chat',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : msg,
					success: function(data, status) {
						$("#chatTextInput").val('');
						$("#playerRankingsChatTextInput").val('');
					},
					error: function(data, status) {
						$("#chatTextInput").val('');
						$("#playerRankingsChatTextInput").val('');
					}
				});
			}
		},
	    
		addMessage: function(chatItem) {
			var chatMessages = $(".chatMessages");
			var userName = chatItem.get("dispName");
			var message = $("<div>"+chatItem.get("message")+"</div>").html();
			chatMessages.append(this.template({
				userName: userName,
				message: message}));
			
			//Change the indicator if the popover isn't open
			var chatDropNav = $(".chatNav");
			if(!chatDropNav.hasClass('open')){
				this.numUnread +=  1;
				var unreadEl = $("#chatUnreadNbr");
				unreadEl.html(this.numUnread);
				unreadEl.removeClass("badge-success");
				unreadEl.addClass("badge-important");
			} else {
				//var chatBox = $(".chatNav .chatMessages");
				//chatBox.first().scrollTop(chatBox.first().prop("scrollHeight"));
			}
			
			var chatBox = $(".chatMessages");
			chatBox.each(function(i, el) {
				$(el).scrollTop($(el).prop("scrollHeight"));
			});
		},
	});
	
	return ChatView;  
});